import {BaseDevice} from "./base.device";
import {Inject, Injectable} from "@angular/core";
import {TokenService} from "../token/token.service";
import {HttpClient} from "@angular/common/http";
import {UserService} from "../user/user.service";
import {BASE_CLIENT, BaseClient} from "../client/base.client";
import {preloaderFinished} from "../auth/preloader";
import {Itoken} from "../auth/itoken";
import {from, Observable} from "rxjs";
import {IShare, ITitle, IWindow, NavigationBar, UserLocation} from "./model";
import {Title} from "@angular/platform-browser";

declare var UniJsBridge;

@Injectable({
  providedIn: "root",
})
export class YunzaiIm extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    private title: Title,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  auth(): Promise<any> {
    if (this.baseclient.yunzaiIm && this.baseclient.yunzaiIm.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    return new Promise<any>((resolve, reject) => {
      UniJsBridge.callHandler("getToken", {}, res => {
        // res:就是上面的callbackFunction的参数
        // 注意：如果uni-app不调用callbackFunction,那么这个回调函数是不会执行
        console.log('getToken response:', JSON.stringify(res));
        const token: any = {};
        token.tokenType = res.data.token_type;
        token.accessToken = res.data.access_token;
        token.scope = res.data.scope;
        token.tokenDateLine = res.data.expires_in;
        // 设置token
        this.tokenService.set(token);
        // 发送/user请求
        this.http
          .get(`${this.baseclient.gateway}/auth/user`)
          .subscribe((response: any) => {
            // 设置user
            this.user.set(response.principal);
            // 加载结束
            preloaderFinished();
            resolve(true);
          });
      });
    });
  }

  openWindow(iwindow: IWindow): void {
    window.open(iwindow.url, '_self');
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("Yunzai_IM暂不支持放置按钮!");
  }

  share(ishare: IShare): void {
    alert("Yunzai_IM暂不支持分享!");
  }

  getToken(): Itoken {
    return this.tokenService.get();
  }

  scanCode(): Observable<string> {
    const p = new Promise<string>(resolve => {
      UniJsBridge.callHandler("clickScan", {}, res => {
        console.log('clickScan response:', JSON.stringify(res));
        const {result} = res.data;
        resolve(result);
      })
    });
    return from(p);
  }

  userLocation(): Observable<UserLocation> {
    const p = new Promise<UserLocation>(resolve => {
      // type参数支持 wgs84和 gcj02
      UniJsBridge.callHandler("userLocation", {type: 'wgs84',}, res => {
        console.log('userLocation response:', JSON.stringify(res));
        const {latitude, longitude} = res.data;
        const address = '暂无address';
        resolve({latitude, longitude, address});
      })
    });
    return from(p);
  }

  validateInWifi(bssids: string[]): Observable<boolean> {
    alert("Yunzai_IM暂不支持WIFI验证!");
    return undefined;
  }

  getWifiMac(): Observable<string> {
    alert("Yunzai_IM暂不支持获取MAC地址!");
    return undefined;
  }

  chooseContacts(count: number): Observable<any> {
    alert("Yunzai_IM暂不支持获取联系人!");
    return undefined;
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("Yunzai_IM暂不支持查询联系人详细信息!");
    return undefined;
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert("Yunzai_IM暂不支持图片上传!");
    return undefined;
  }

  openReadWithTimer(
    url: any,
    openType: any,
    title: any,
    id: any,
    type: any
  ): Observable<any> {
    alert("Yunzai_IM暂不支持读物时间统计!");
    return undefined;
  }

  uploadMovie(limitMinute: number): Observable<any> {
    alert("Yunzai_IM暂不支持视频上传!");
    return undefined;
  }

  fileBrowser(url: string, title: string): Observable<any> {
    alert("Yunzai_IM暂不支持此功能!");
    return undefined;
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
}
